var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#E4F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.08317 17.8332H7.33317C7.02375 17.8332 6.72701 17.7103 6.50821 17.4915C6.28942 17.2727 6.1665 16.9759 6.1665 16.6665V12.5832C6.1665 12.2738 6.28942 11.977 6.50821 11.7582C6.72701 11.5394 7.02375 11.4165 7.33317 11.4165H9.08317M13.1665 10.2498V7.9165C13.1665 7.45238 12.9821 7.00726 12.6539 6.67907C12.3258 6.35088 11.8806 6.1665 11.4165 6.1665L9.08317 11.4165V17.8332H15.6632C15.9445 17.8364 16.2176 17.7377 16.4319 17.5555C16.6463 17.3733 16.7876 17.1197 16.8298 16.8415L17.6348 11.5915C17.6602 11.4243 17.6489 11.2536 17.6018 11.0912C17.5546 10.9287 17.4727 10.7785 17.3618 10.6509C17.2508 10.5233 17.1134 10.4213 16.9591 10.352C16.8048 10.2828 16.6373 10.2479 16.4682 10.2498H13.1665Z",
    stroke: "#35A8AC",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbs);
export default __webpack_public_path__ + "static/media/thumbs.2c044714bacc976e421f3f22bf57afe6.svg";
export { ForwardRef as ReactComponent };